"use strict";
module.exports = {
    STOCK_TAKING_COMPLETED: 'Inventering klar',
    STOCK_TAKING_STOCK_TAKEN: 'Inventerings rader uppdaterade',
    STOCK_TAKING_UPDATED: 'Inventering uppdaterad',
    STOCK_TAKING_CREATED: 'Inventering skapad',
    ARTICLE_IN_INVENTORY_CREATED: 'inventory article created',
    ARTICLE_IN_INVENTORY_UPDATED: 'inventory article updated',
    END_CUSTOMER_IN_INVENTORY_CREATED: 'inventory end-customer created',
    END_CUSTOMER_IN_INVENTORY_UPDATED: 'inventory end-customer updated',
};
